import { render, staticRenderFns } from "./ReceiveColli.vue?vue&type=template&id=206af6c6&scoped=true"
import script from "./ReceiveColli.vue?vue&type=script&lang=js"
export * from "./ReceiveColli.vue?vue&type=script&lang=js"
import style0 from "./ReceiveColli.vue?vue&type=style&index=0&id=206af6c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206af6c6",
  null
  
)

export default component.exports